import { createAction } from "@reduxjs/toolkit";

export const setChainId = createAction<{ chainId: string }>("app/setChainId");
export const setBalance = createAction<{ balance: string }>("app/setBalance");
